const getTokenValue = (token = '') => {
  const parts = String(token || '').trim().split(/\s+/).filter(Boolean);
  if (parts.length >= 2 && ['Bearer', 'Token', 'JWT', 'Basic'].includes(parts[0])) {
    return parts.slice(1).join(' ');
  }
  return parts.join(' ');
};

const getAuthorizationCandidates = (token = '') => {
  const tokenString = String(token || '').trim();
  const tokenValue = getTokenValue(tokenString);
  const candidates = [];

  if (tokenString) {
    candidates.push(tokenString);
  }

  if (tokenValue) {
    candidates.push(`Token ${tokenValue}`);
    candidates.push(`Bearer ${tokenValue}`);
    candidates.push(`JWT ${tokenValue}`);
  }

  return [...new Set(candidates)];
};

export const fetchWithAuthFallback = async (url, options = {}, token = '') => {
  const baseHeaders = options.headers || {};
  const authorizationCandidates = getAuthorizationCandidates(token);
  const requestVariants = authorizationCandidates.length > 0
    ? authorizationCandidates.map((authorization) => ({
      ...options,
      headers: {
        ...baseHeaders,
        Authorization: authorization,
      },
    }))
    : [];

  requestVariants.push({
    ...options,
    headers: { ...baseHeaders },
  });

  let lastResponse = null;

  for (const requestOptions of requestVariants) {
    const response = await fetch(url, requestOptions);
    if (response.status !== 401) {
      return response;
    }
    lastResponse = response;
  }

  return lastResponse;
};
